import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import styles from './OurServices.module.css'; // Stylesheet using CSS Modules
import { services } from './servicesData'; // Adjust path if needed

gsap.registerPlugin(ScrollTrigger);

const OurServices = () => {
  const sectionRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    let ctx = gsap.context(() => {
      const cards = gsap.utils.toArray(gridRef.current.children);

      cards.forEach((card, index) => {
        const anim = gsap.from(card, {
          opacity: 0,
          x: 60,
          y: 60,
          scale: 0.95,
          duration: 0.8,
          ease: 'power3.out',
          paused: true,
          delay: index * 0.05,
        });

        ScrollTrigger.create({
          trigger: card,
          animation: anim,
          start: 'top 85%',
          end: 'bottom 15%',
          toggleActions: 'restart reverse restart reverse',
          // markers: process.env.NODE_ENV === 'development',
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <section className={styles.ourServicesSection} ref={sectionRef}> {/* Updated class */}
        <div className={styles.container}> {/* Updated class */}
          <h2 className={styles.sectionTitle}>Our Services</h2> {/* Updated class */}
          <div className={styles.servicesGrid} ref={gridRef}> {/* Updated class */}
            {services.map((service) => (
              <article key={service.id} className={styles.serviceCard}> {/* Updated class */}
                <div className={styles.serviceImageContainer}> {/* Updated class */}
                  <img
                    src={service.image}
                    alt={service.title}
                    className={styles.serviceImage} /* Updated class */
                    loading="lazy"
                  />
                  <div className={styles.imageOverlay}></div> {/* Updated class (if specific styles exist, ensure it's styles.imageOverlay) */}
                </div>
                <div className={styles.serviceContent}> {/* Updated class */}
                  <h3 className={styles.serviceHeading}> {/* Updated class */}
                    {service.title}
                  </h3>
                  <p className={styles.serviceDescription}> {/* Updated class */}
                    {service.description}
                  </p>
                  {/* MODIFIED LINK HERE */}
                  <a href="/contact" className={styles.readMoreLink}> {/* Updated class & href */}
                    Contact Us <span className={styles.arrow}>→</span> {/* Updated class for arrow if styled separately */}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Themed and uses CSS Modules if uncommented */}
      {/*
      <section className={styles.ourServicesCta}>
         <div className={styles.container}>
            <h2>Let's Build Something Great Together</h2>
            <p>Discuss your project with our experts and receive a tailored proposal.</p>
            <a href="/get-proposal" className={styles.ourServicesCtaButton}>
              Get Your Proposal
            </a>
         </div>
      </section>
      */}
    </>
  );
};

export default OurServices;